module.exports = __webpack_public_path__ + "img/icon-red-dot.7e0d0522.svg";